// Styles
import '@mdi/font/css/materialdesignicons.css'
// import '@/assets/scss/styles.scss'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
// import { VVirtualScroll } from 'vuetify/labs/VVirtualScroll'
// import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader'

const myCustomLightTheme = {
	dark: false,
	colors: {
		primary: '#3F73AB',
		secondary: '#D9E3EE',
		accent: '#EA5D31',
		green: '#83C72C',
		success: '#42A162',
		warning: '#EAB631',
		error: '#EA4C42',
		background: '#EDF1F2',
		white: '#ffffff',
		textSecondary: "#B6BBC2",
		textMuted: "#86919D",
		black: "#22282B",
		black900: "#1d2126",
		text500: "#B6BBC2",
		textSecondary700: "#576674",
		textSecondary800: "#3F464E",
		textBody: "#1D2126",
		text900: "#0D1722",
		bgTechMap: "#DCE2E3",
		red: '#EA4C42',
		lightGrey: '#f6f8f9',

		icon600: '#7E9AAF',


		'gray-30': '#DEE6E8',
		'light-30': '#FAFBFB',
	}
}

export default createVuetify({
	components: {
		// VVirtualScroll,
		// VSkeletonLoader,
	},
	theme: {
		defaultTheme: 'myCustomLightTheme',
		themes: {
			myCustomLightTheme,
		}
	},
})
